import React from "react";






export default function Header() {
    return(
        <div className="header_container">
            <div className="header">
                <div className="headerLogo">
                    <h1>MEMORY</h1>
                </div>
                <div className="list">
                    <ul>
                        <li>產品介紹</li>
                        <li>常見問題</li>
                        <li>聯絡我們</li>
                        <li>登入</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}